import noop from 'lodash/noop';
import zipObject from 'lodash/zipObject';
import isFunction from 'lodash/isFunction';
import range from 'lodash/range';

const $hnxLoginProvider = function () {
	return {
		__data: {
			statusPromise: null,
			loggedIn: false,
			userData: null,
			pingInterval: null,
			mappedPermissions: null,
			callbacks: {
				loginSuccess: noop,
				loginError: noop,
				logoutSuccess: noop,
				logoutError: noop
			},
			api: {}
		},

		get status() {
			return this.__data.loggedIn;
		},

		get userData() {
			return this.__data.userData;
		},

		get permissions() {
			return this.__data.mappedPermissions;
		},

		loginCallback (onSuccess, onError) {
			this.__data.callbacks.loginSuccess = isFunction(onSuccess) ? onSuccess : noop;
			this.__data.callbacks.loginError = isFunction(onError) ? onError : noop;
		},

		logoutCallback (onSuccess, onError) {
			this.__data.callbacks.logoutSuccess = isFunction(onSuccess) ? onSuccess : noop;
			this.__data.callbacks.logoutError = isFunction(onError) ? onError : noop;
		},

		pingSet () {
			if (this.__data.pingInterval === null) {
				const intervalId = window.setInterval(() => this.__data.api.sessionPing(), 600000);
				this.__data.pingInterval = intervalId;
			}
		},
		pingCancel () {
			if (this.__data.pingInterval !== null) {
				window.clearInterval(this.__data.pingInterval);
				this.__data.pingInterval = null;
			}
		},

		prepareUiPermissions (array) {
			this.__data.mappedPermissions = zipObject(array, range(array.length).map(() => true));
		},

		currentUser (reload) {
			const self = this;
			let promise;

			if (reload) {
				this.__data.statusPromise = null;
			}

			if (this.__data.statusPromise === null) {
				promise = this.__data.statusPromise = this.__data.api.current().then((data) => {
					if (data.result.success) {
						self.pingSet();
						self.__data.userData = data.payload;
						self.prepareUiPermissions(data.payload.permissions);
						self.__data.loggedIn = true;
						return data.payload;
					} else {
						self.__data.userData = null;
						self.__data.loggedIn = false;
						self.__data.mappedPermissions = null;
						return null;
					}
				});
			} else {
				promise = this.__data.statusPromise;
			}

			return promise;
		},

		login (email, password, appId) {
			const self = this;
			this.__data.statusPromise = null;

			return this.__data.api.login(email, password, appId).then((data) => {
				if (data.result.success) {
					self.pingSet();
					self.__data.userData = data.payload;
					self.prepareUiPermissions(data.payload.permissions);
					self.__data.loggedIn = true;
					self.__data.callbacks.loginSuccess();
				} else {
					self.__data.userData = null;
					self.__data.loggedIn = false;
					self.__data.mappedPermissions = null;
					self.__data.callbacks.loginError();
				}
				return data.result.success;
			});
		},

		logout () {
			const self = this;
			return this.__data.api.logout().then((data) => {
				if (data.result.success) {
					self.pingCancel();
					self.__data.loggedIn = false;
					self.__data.statusPromise = null;
					self.__data.userData = null;
					self.__data.callbacks.logoutSuccess();
					return true;
				} else {
					self.__data.callbacks.logoutError();
					return false;
				}
			});
		},

		forceClearData () {
			this.pingCancel();
			this.__data.mappedPermissions = null;
			this.__data.userData = null;
			this.__data.statusPromise = null;
			this.__data.loggedIn = false;
		}
	};
}();

export default $hnxLoginProvider;
